export default __webpack_public_path__ + "static/media/advance.4cc62696.svg";